import React from 'react'
import '../../assest/Virtual.css';
import '../../assest/index.css';
import '../../assest/Eventinglist.css';
import '../../assest/jobpage.css';
import Card from '../../component/card';
import Eventlistcard from '../../component/Eventlistcard';
import Jobcard from '../../component/jobcard';
import Jobpostcard from '../../component/Jobpostcard';
import Job_categorycard from '../../component/Job_categorycard';
import Babysittercard from '../../component/babysitter'
import Button from '../../component/button';
import Footer_menu from '../../component/footer_menu';
import style from './Eventinglistingpage.module.css';
import $ from 'jquery';
import { useState } from 'react';

export default function Eventlistpage() {

    const [toogle, setToggle] = useState(false)
    $(function () {
        $("#logins").click(function () {
            $("#signup").hide();
            $(".modal-backdrop").hide();
        });
    });
    return (
        <>
            <div className={style.Main_wrapper_section}>
                <header className="App-header Eventing-banner">

                    <div className="header">
                        <div className="container-fluid">
                            <div className=" top-header">
                                <div className=" address">
                                    Address: California,Los angeles
                                </div>
                                <div className=" icons">
                                    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13.2686 0.724609H10.3607C8.63501 0.724609 6.71559 1.4646 6.71559 4.01496C6.72401 4.9036 6.71559 5.75466 6.71559 6.71247H4.71924V9.95142H6.77737V19.2758H10.5593V9.88989H13.0555L13.2813 6.70338H10.4941C10.4941 6.70338 10.5004 5.28589 10.4941 4.87424C10.4941 3.8664 11.5227 3.92411 11.5846 3.92411C12.074 3.92411 13.0257 3.92557 13.27 3.92411V0.724609H13.2686Z" fill="white" />
                                    </svg>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_2306_49377)">
                                            <path d="M6.14651 9.00008C6.14651 7.42391 7.42391 6.14582 9.00008 6.14582C10.5763 6.14582 11.8543 7.42391 11.8543 9.00008C11.8543 10.5763 10.5763 11.8543 9.00008 11.8543C7.42391 11.8543 6.14651 10.5763 6.14651 9.00008ZM4.60354 9.00008C4.60354 11.4283 6.57185 13.3966 9.00008 13.3966C11.4283 13.3966 13.3966 11.4283 13.3966 9.00008C13.3966 6.57185 11.4283 4.60354 9.00008 4.60354C6.57185 4.60354 4.60354 6.57185 4.60354 9.00008ZM12.5432 4.42925C12.5432 4.99637 13.0031 5.45698 13.5709 5.45698C14.138 5.45698 14.5986 4.99637 14.5986 4.42925C14.5986 3.86213 14.1387 3.40221 13.5709 3.40221C13.0031 3.40221 12.5432 3.86213 12.5432 4.42925ZM5.54066 15.9694C4.70589 15.9314 4.2522 15.7924 3.95066 15.6748C3.55091 15.5192 3.26597 15.3338 2.96581 15.0343C2.66635 14.7349 2.4803 14.4499 2.32538 14.0502C2.20781 13.7487 2.0688 13.295 2.03076 12.4602C1.98926 11.5576 1.98096 11.2865 1.98096 9.00008C1.98096 6.71363 1.98995 6.44321 2.03076 5.53997C2.0688 4.7052 2.2085 4.2522 2.32538 3.94997C2.48099 3.55022 2.66635 3.26528 2.96581 2.96512C3.26528 2.66565 3.55022 2.47961 3.95066 2.32469C4.2522 2.20712 4.70589 2.06811 5.54066 2.03007C6.44321 1.98857 6.71432 1.98027 9.00008 1.98027C11.2865 1.98027 11.557 1.98926 12.4602 2.03007C13.295 2.06811 13.748 2.20781 14.0502 2.32469C14.4499 2.47961 14.7349 2.66565 15.035 2.96512C15.3345 3.26459 15.5199 3.55022 15.6755 3.94997C15.793 4.25151 15.9321 4.7052 15.9701 5.53997C16.0116 6.44321 16.0199 6.71363 16.0199 9.00008C16.0199 11.2858 16.0116 11.557 15.9701 12.4602C15.9321 13.295 15.7924 13.7487 15.6755 14.0502C15.5199 14.4499 15.3345 14.7349 15.035 15.0343C14.7356 15.3338 14.4499 15.5192 14.0502 15.6748C13.7487 15.7924 13.295 15.9314 12.4602 15.9694C11.5576 16.0109 11.2865 16.0192 9.00008 16.0192C6.71432 16.0192 6.44321 16.0109 5.54066 15.9694V15.9694ZM5.47012 0.489859C4.55858 0.531355 3.93614 0.675901 3.39184 0.887533C2.82887 1.10608 2.35166 1.39932 1.87515 1.87515C1.39932 2.35097 1.10608 2.82818 0.887533 3.39184C0.675901 3.93614 0.531355 4.55858 0.489859 5.47012C0.447671 6.38304 0.437988 6.6749 0.437988 9.00008C0.437988 11.3253 0.447671 11.6171 0.489859 12.53C0.531355 13.4416 0.675901 14.064 0.887533 14.6083C1.10608 15.1713 1.39863 15.6492 1.87515 16.125C2.35097 16.6008 2.82818 16.8934 3.39184 17.1126C3.93683 17.3243 4.55858 17.4688 5.47012 17.5103C6.38373 17.5518 6.6749 17.5622 9.00008 17.5622C11.326 17.5622 11.6171 17.5525 12.53 17.5103C13.4416 17.4688 14.064 17.3243 14.6083 17.1126C15.1713 16.8934 15.6485 16.6008 16.125 16.125C16.6008 15.6492 16.8934 15.1713 17.1126 14.6083C17.3243 14.064 17.4695 13.4416 17.5103 12.53C17.5518 11.6164 17.5615 11.3253 17.5615 9.00008C17.5615 6.6749 17.5518 6.38304 17.5103 5.47012C17.4688 4.55858 17.3243 3.93614 17.1126 3.39184C16.8934 2.82887 16.6008 2.35166 16.125 1.87515C15.6492 1.39932 15.1713 1.10608 14.609 0.887533C14.064 0.675901 13.4416 0.530664 12.5307 0.489859C11.6178 0.448362 11.326 0.437988 9.00077 0.437988C6.6749 0.437988 6.38373 0.447671 5.47012 0.489859" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_2306_49377">
                                                <rect width="17.1242" height="17.1242" fill="white" transform="translate(0.437988 0.437988)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <button type="button" className=" post-btn">Post Ad</button>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="main-body">
                        <div className="container-fluid">
                            <div className=" navbar_list">
                                <div className="home-icon">
                                    <img src="/images/menehariya_logo.svg" alt="logo" />
                                </div>
                                <div className=" menus">
                                    <ul className="nav-links  ">
                                        <li>Rooms for Rent</li>
                                        <li>Jobs</li>
                                        <li>Events</li>
                                        <li>Buy & Sell</li>
                                        <li>Local Biz and Services</li>
                                        <li>Babysitters and Nannies</li>
                                    </ul>
                                </div>

                                {
                                    toogle ?
                                        <div className=" button">
                                            <button type="button" className="btn btn-outline-light" data-bs-toggle="modal" data-bs-target="#signup">Sign in / up</button>
                                        </div> :

                                        <div className="profile-list">
                                            <div>
                                                <i className="fa-brands fa-facebook-messenger"></i>
                                            </div>
                                            <div>
                                                <i className="fa-solid fa-bell"></i>
                                            </div>
                                            <div className="profile-name">
                                                <h3>Robert</h3>
                                                <img src="/images/Ellipse 1 (5).png" alt="" />
                                                <div className="dropdown">
                                                    <i className="fa-solid fa-chevron-down"></i>
                                                </div>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>

                        <div className="top-banner">
                            <h1>Find Event Vestibulum ante ipsum</h1>
                            <p>Vestibulum ante ipsum primis in faucibus orci luctus et
                                ultrices posure  cubilia curae; proin sodales ultrices nulla
                                blandit volutpat.
                            </p>


                            <div className="card-body p-0">
                                <form id="search-form">
                                    <div className="search-bar">
                                        <div className="location-bar">
                                            <img src="/images/location pin.svg" alt="logo" />
                                            <img className="location-bar-icon-dropdown" src="/images/chevron-down.svg" alt="logo" />
                                            <select className="form-control" id="exampleFormControlSelect1">
                                                <option>Location</option>
                                                <option>London</option>
                                                <option>Boston</option>
                                                <option>Mumbai</option>
                                                <option>New York</option>
                                                <option>Toronto</option>
                                                <option>Paris</option>
                                            </select>
                                        </div>
                                        <div className="input-bar">
                                            <input type="text" placeholder="Find house and rooms for rent" className="form-control" id="search" name="search" />
                                        </div>
                                        <div className="submit-button">
                                            <button type="submit" className="btn btn-base">
                                                <i className="fa fa-search" aria-hidden="true"></i> <p>Search</p>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                </header>
                <div className="buttons-boxes">
                    <div className="button-black-active">
                        <button>View All (260)</button>
                    </div>
                    <div className="button-border">
                        <button>Local Job (170)</button>
                    </div>
                    <div className="button-border">
                        <button>Virtual Job (30)</button>
                    </div>
                </div>
            
                    <div className="container-fluid">
                        <div className="body-card">
                            <div className=" body-card-text">
                                Featured Virtual assistant jobs
                            </div>
                            <div className="view-btn">
                                <button type="button" className="btn btn-view">View All</button>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="cards-items">
                            <Eventlistcard title="" titlebtn="View Details" localbtn="Local" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />

                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="body-card">
                            <div className=" body-card-text">
                                Virtual  jobs
                            </div>
                            <div className="view-btn">
                                <button type="button" className="btn btn-view">View All</button>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="cards-items">
                            <Eventlistcard title="" titlebtn="View Details" localbtn="Local" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />

                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="cards-items">
                            <Eventlistcard title="" titlebtn="View Details" localbtn="Local" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                            <Eventlistcard title="" titlebtn="View Details" location="" duration="" titleColor="" />

                        </div>
                    </div>
                    <div className="pagination-number-list">
                        <div className="left-button">
                            <button className="left-icon"><i className="fa-solid fa-arrow-left"></i></button>
                            <button className="number-icon"><span className="orange-text">1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>...</span><span>9</span></button>
                            <button className="right-icon"><i className="fa-solid fa-arrow-right"></i></button>
                        </div>
                    </div>

                    <div className={style.Jobs_wraper_palces}>
                        <h2>Events by Area</h2>
                        <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Proin sodales ultrices nulla blandit volutpat Vestib ulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae.

                        </p>
                        <div className={style.Jobs_wraper_images}>
                            <div>
                                <img src="/images/Group 1686552429.png" alt="" />
                                <div className={style.place_text}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {/* <h3>Spain</h3>
                                    <p>25 listings</p> */}

                                </div>
                            </div>
                            <div>
                                <img src="/images/Group 1686552017 (1).png" alt="" />
                                <div className={style.place_text}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {/* <h3>USA</h3>
                                    <p>25 listings</p> */}

                                </div>
                            </div>
                            <div>
                                <img src="/images/Group 1686552016.png" alt="" />
                                <div className={style.place_text}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {/* <h3>UAE</h3>
                                    <p>25 listings</p> */}

                                </div>
                            </div>
                        </div>
                        <div className={style.virtual_job_box}>
                        <div>
                                <img src="/images/Group 1686552020.png" alt="" />
                                <div className={style.place_text_virtual}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {/* <h3>UAE</h3>
                                    <p>25 listings</p> */}

                                </div>
                            </div>
                            <div>
                                <img src="/images/Group 1686552019.png" alt="" />
                                <div className={style.place_text_virtual}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {/* <h3>UAE</h3>
                                    <p>25 listings</p> */}

                                </div>
                            </div>

                        </div>
                    </div>
                <div className="different-jobs-catogery">
                    <h2>Different Job Categories</h2>
                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Proin sodales ultrices nulla blandit volutpat Vestib ulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae.

                    </p>
                    <div className="different-jobs-catogery-list cards-items">
                        <Job_categorycard title="" titlebtn="View Details" localbtn="Local" />
                        <Job_categorycard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                        <Job_categorycard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                        <Job_categorycard title="" titlebtn="View Details" location="" duration="" titleColor="" />
                    </div>
                </div>





                <div className="apps">
                    <div className="apps-section">
                        <h4>TRY THE MENEHARIYAAPP </h4>
                        <p>Buy , sell and find just about anything <br />
                            using the app on your mobile.</p>
                    </div>


                    <div className="apps-section1">
                        <h6>GET YOUR APP TODAY </h6>
                        <div className="links-images">
                            <img src="/images/app.png" alt="logo" />
                            <img src="/images/google.png" alt="logo" />
                            <img src="/images/gallery.jpg" alt="logo" />
                        </div>

                    </div>
                </div>
                <div className="modal bd-example-modal-sm" id="login">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title"><b>Log into your account</b></h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">Email </label>
                                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter your Email" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="exampleInputPassword1">Password <span>*</span></label>
                                        <input type="password" className="form-control" id="exampleInputPassword1" placeholder="Create a password" />
                                    </div>

                                    <div className="form-group">
                                        <button type="submit" className="btn btn-confirm">
                                            Confirm
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-signup">
                                            <span><img style={{ width: '5%', height: '5%' }} src="/images/googleicon.png" alt="logo" />
                                                &nbsp;&nbsp; Sign up with Google</span>
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-signup">
                                            <span><img style={{ width: '5%', height: '5%' }} src="/images/facebook.png" alt="logo" />
                                                &nbsp;&nbsp;  Sign up with Facebook </span>
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-signup">
                                            <span><img style={{ width: '10%', height: '5%' }} src="/images/apple.png" alt="logo" />
                                                &nbsp;&nbsp; Sign up with Apple </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal bd-example-modal-sm" id="signup">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title"><b>Sign up</b></h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="exampleInputName1">Name <span>*</span></label>
                                        <input type="text" className="form-control" id="exampleInputName1" aria-describedby="nameHelp" placeholder="Enter your name" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">Email <span>*</span></label>
                                        <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter your Email" />
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="exampleInputPassword1">Password <span>*</span></label>
                                        <input type="password" className="form-control" id="exampleInputPassword1" placeholder="Create a password" />
                                    </div>
                                    <p>Must be at least 8 characters.</p>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-confirm">
                                            Confirm
                                        </button>
                                        <p className="account">Already Have an account &nbsp;
                                            <a data-bs-toggle="modal" data-bs-target="#login" id="logins">Login</a></p>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-signup">
                                            <span><img style={{ width: '5%', height: '5%' }} src="/images/googleicon.png" alt="logo" />
                                                &nbsp;&nbsp; Sign up with Google</span>
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-signup">
                                            <span><img style={{ width: '5%', height: '5%' }} src="/images/facebook.png" alt="logo" />
                                                &nbsp;&nbsp;  Sign up with Facebook </span>
                                        </button>
                                    </div>
                                    <div className="form-group">
                                        <button type="submit" className="btn btn-signup">
                                            <span><img style={{ width: '10%', height: '5%' }} src="/images/apple.png" alt="logo" />
                                                &nbsp;&nbsp; Sign up with Apple </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
